import { useReseller } from 'hooks/Reseller/useReseller';
import { useQuery } from '@tanstack/react-query';
import { fetchAllDCSBundles } from 'services/dcs/bundle';
import { ONE_HOUR_IN_MS } from 'globalConstants';

export const useDCSBundlesQuery = () => {
  const { resellerId } = useReseller();

  const queryInfo = useQuery(
    ['fetchAllDCSBundles', resellerId],
    async () => {
      const response = await fetchAllDCSBundles(resellerId);
      return response.data;
    },
    {
      staleTime: ONE_HOUR_IN_MS,
      enabled: !!resellerId,
    },
  );

  return {
    ...queryInfo,
    isLoading: queryInfo.isLoading,
  };
};
